import styled from '@emotion/styled';
import { Spin } from 'antd';
// import theme from '../../theme';
import * as T from '../Typography';
import setMargin from './../../helpers/set-margin';

export const decideBackground = (variant, theme) => {
  switch (variant) {
    case 'primary':
      return theme.gradients.secondary;
    case 'secondary':
      return theme.colors.primaryMain;
    case 'tertiary':
      return theme.colors.white;
    default:
      return 'transparent';
  }
};

export const Button = styled.button`
  ${setMargin};
  display: flex;
  justify-content: ${({ variant, icon }) =>
    variant === 'tertiary' && icon ? 'space-between' : 'center'};
  flex-direction: ${({ variant, icon }) =>
    variant === 'tertiary' && icon ? 'row-reverse' : 'row'};
  align-items: center;
  width: ${({ w }) => w || '100%'};
  height: ${({ icon, variant }) => {
    if (icon && variant === 'primary') {
      return '67px';
    } else {
      return '58px';
    }
  }};
  color: ${({ variant, theme }) =>
    variant === 'tertiary' ? theme.colors.neutralMain : theme.colors.white};
  position: relative;
  background: ${({ variant, theme }) => decideBackground(variant, theme)};
  border: 2px solid;
  border-color: ${({ variant, theme }) =>
    variant === 'secondary'
      ? theme.colors.secondaryDark
      : theme.colors.neutralMain};
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 700;
  padding: 0 14px;

  /* clicking style */
  :active {
    opacity: 0.9;
    transform: translateY(1px) scale(0.99);
  }

  /* for disabled style */
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled, isLoading }) =>
    disabled || isLoading ? 'not-allowed' : 'pointer'};
`;

export const Loading = styled(Spin)`
  span {
    line-height: 24px;
    margin-inline-start: 10px;
    color: ${({ theme, variant }) =>
      variant === 'secondary' ? theme.colors.neutralMain : theme.colors.white};
  }
`;

export const Label = styled(T.P)``;
